module.exports = __webpack_public_path__ + "static/img/tab1_en.a7264c9a.png";